import React, {Component } from "react";
import {Button, Col, Container, Form, Row, Alert} from "react-bootstrap";
import BuildsTable from "../components/BuildsTable";
import BuildService from "../services/BuildService";
import {FIRMWARE_TYPE} from "../constants/Constants";
import GoldenBuildModal from "../components/GoldenBuildModal";
import Helper from "../utils/Helper";

const strings = require('../resources/strings.json');

export default class Build extends Component {

    state = {
        buildList: [],
        buildUrl: "",
        buildType: FIRMWARE_TYPE.SWITCH_DEVICE_IMAGE,
        buildDialogErrors: [null],
        showUpdateGoldenBuild: false,
        userInfo : "",
        requestMail: "",
        deviceList: [],
        showUpgrade: false,
        switchBuilds: [],
        acBuilds: [],
        selectedDevices: [],
        selectedAc: [],
        userEmail: "",
        selectedPremisesObject: {},
        selectedPremises: "",
        premisesDeviceList: [],
        deviceConfigShow: false,
        configTimestamp: 0,
        configMacId: '',
        rebootDeviceShow: false,
        restartMacId: '',
    }

    constructor(props) {
        super(props);
        this.validateForm = this.validateForm.bind(this);
        this.addBuild = this.addBuild.bind(this);
        this.handleUrlChange = this.handleUrlChange.bind(this);
        this.onSelectFirmwareType = this.onSelectFirmwareType.bind(this);
        this.closeGoldenBuildModal = this.closeGoldenBuildModal.bind(this);
        this.showGoldenBuildModal = this.showGoldenBuildModal.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleFetchClick = this.handleFetchClick.bind(this);
        this.separateBuildBasedOnDeviceType = this.separateBuildBasedOnDeviceType.bind(this);
        this.getDeviceList = this.getDeviceList.bind(this);
        this.updateGoldenBuild = this.updateGoldenBuild.bind(this);
        this.getBuildList = this.getBuildList.bind(this);
        this.deleteBuild = this.deleteBuild.bind(this);
        this.getBuildId = this.getBuildId.bind(this);
        this.handleRefresh = this.handleRefresh.bind(this);
        this.onSelectPremise = this.onSelectPremise.bind(this);
        this.selectedPremisesRefresh = this.selectedPremisesRefresh.bind(this);
        this.getErrorMessage = this.getErrorMessage.bind(this);
    }
    
    async componentDidMount() {
        await this.getBuildList();
    }

    async getBuildList () {
        try {
            const builds = await BuildService.getBuilds();
            const buildBasedOnDeviceType = this.separateBuildBasedOnDeviceType(builds)
            this.setState({
                buildList: builds,
                switchBuilds: buildBasedOnDeviceType.dataSwitch,
                acBuilds: buildBasedOnDeviceType.dataAc
            })
        } catch (e) {
            alert("There was an error fetching builds")
        }
    }

    separateBuildBasedOnDeviceType (buildList) {
        let dataSwitch = [], dataAc = [];
        for (let i = 0; i < buildList.length; i++) {
            let buildData = buildList[i];
            let build = {};
            build.id = buildData.id;
            build.buildUrl = buildData.buildUrl;
            build.firmwareType = buildData.firmwareType;
            switch(buildData.firmwareType){
                case FIRMWARE_TYPE.SWITCH_DEVICE_IMAGE: {
                    build.firmwareTypeReadable = strings.switchImage;
                    break;
                }
                case FIRMWARE_TYPE.SWITCH_STM_IMAGE: {
                    build.firmwareTypeReadable = strings.stmImage;
                    break;
                } 
                case FIRMWARE_TYPE.AC_DEVICE_IMAGE: {
                    build.firmwareTypeReadable =  strings.acImage;
                    break;
                }
                default:{
                    build.firmwareTypeReadable =  "";
                }    

            }
            const date = new Date(buildData.addedOn);
            build.addedOn = date.toLocaleString();
            build.version = buildData.major + "." + buildData.minor + "." + buildData.revision;
            if(build.firmwareType === FIRMWARE_TYPE.WIFI_IMAGE)
            {
                dataAc.push(build);
                dataSwitch.push(build)
            }
            else if(build.firmwareType === FIRMWARE_TYPE.AC_DEVICE_IMAGE || build.firmwareType === FIRMWARE_TYPE.PCB_IMAGE) {
                dataAc.push(build);
            } else {
                dataSwitch.push(build);
            } 
        }
        return {dataSwitch, dataAc};
    }

    handleInputChange = (event) => {
        this.setState({ 
            userInfo: event.target.value
        })
    };

    handleFetchClick = async event => {
        this.state.userInfo= this.state.userInfo.trim();
        if (!this.validateInput()) {
            alert(strings.enterValidEmailMac)
            return;
        }
        this.setState({premisesDeviceList: [], selectedPremises: "", selectedPremisesObject: {}, requestMail: this.state.userInfo.trim(), deviceList: [], selectedDevices: [], selectedAc: []});
        await this.getDeviceList(this.state.userInfo.trim()); 
    };


    validateInput = () => {
        return (
            this.state.userInfo && 
            this.state.userInfo != "" &&
            (Helper.validateEmail(this.state.userInfo) ||
            Helper.validateMac(this.state.userInfo))
        )
    }

    async getDeviceList(userInfo) {
        try {
            const response = await BuildService.getDeviceList(userInfo);
            if(response.error){
                throw new Error(response.message);
            }
            this.setState({userEmail: response.email, premisesDeviceList: response.premisesDevicesList, selectedPremises: "", deviceList: [], selectedDevices: [], selectedAc: []})
        } catch (e) {
            alert(e.message);
        }
    }
    
    handleUpgrade = () => {
        this.setState({ showUpgrade: true})
    } 
    
    handleRefresh = async () => {
        this.state.userInfo= this.state.userInfo.trim();
        if (!this.validateInput()) {
            alert(strings.enterValidEmailMac);
            return;
        }
        const premises = this.state.selectedPremises 
        await this.getDeviceList(this.state.userInfo.trim()); 
        if(premises !== "") {
            this.selectedPremisesRefresh(premises);
        }
    }

    //TODO: This will only work if premises name are unique
    selectedPremisesRefresh = (premisesName) => {
        for(const premises of this.state.premisesDeviceList)  {
            if(premisesName === premises.name) {
                this.setState({
                    selectedPremises: premises.name,
                    deviceList: premises.deviceList,
                    selectedDevices: [], 
                    selectedAc: []
                })
            }
        }
    }

    handleUrlChange = (event) => {
        this.setState({ buildUrl: event.target.value });
    };

    onSelectFirmwareType = (event) => {
        this.setState({ buildType: event.target.value });
    };

    showGoldenBuildModal = () => {
        this.setState({ showUpdateGoldenBuild: true });
    }

    closeGoldenBuildModal = () => {
        this.setState({ showUpdateGoldenBuild: false });
    }

    showUpgradeModal = () => {
        this.setState({ showUpgrade: true });
    }

    closeUpgradedModal = () => {
        this.setState({ showUpgrade: false,  });
    }
    async validateForm() {
        let errors = [null, null];
        this.setState({buildDialogErrors: errors});
        if (!this.state.buildUrl || this.state.buildUrl === "") {
            errors[0] = "";
        }
        if (errors[0] != null) {
            this.setState({buildDialogErrors: errors});
            return
        }
        await this.addBuild();
    }

    async addBuild () {
        let request = {}
        switch(this.state.buildType){
            case FIRMWARE_TYPE.SWITCH_DEVICE_IMAGE: {
                request = {
                    major: parseInt(this.state.buildUrl.substring(this.state.buildUrl.lastIndexOf("/")+1,this.state.buildUrl.lastIndexOf("/")+3)),
                    minor: parseInt(this.state.buildUrl.substring(this.state.buildUrl.lastIndexOf("/")+3,this.state.buildUrl.lastIndexOf("/")+5)),
                    revision: parseInt(this.state.buildUrl.substring(this.state.buildUrl.lastIndexOf("/")+5,this.state.buildUrl.lastIndexOf("_nuro"))),
                    buildUrl: this.state.buildUrl.trim(),
                    firmwareType: this.state.buildType
                };
                break;
            }
            case FIRMWARE_TYPE.SWITCH_STM_IMAGE: {
                request = {
                    major: 1,
                    minor: 0,
                    revision: parseInt(this.state.buildUrl.substring(this.state.buildUrl.lastIndexOf(".")-2,this.state.buildUrl.lastIndexOf("."))),
                    buildUrl: this.state.buildUrl.trim(),
                    firmwareType: this.state.buildType
                };
                break;
            }
            case FIRMWARE_TYPE.AC_DEVICE_IMAGE: {
				request = {
                    major: parseInt(this.state.buildUrl.substring(this.state.buildUrl.lastIndexOf("/")+1,this.state.buildUrl.lastIndexOf("/")+3)),
                    minor: parseInt(this.state.buildUrl.substring(this.state.buildUrl.lastIndexOf("/")+3,this.state.buildUrl.lastIndexOf("/")+5)),
                    revision: parseInt(this.state.buildUrl.substring(this.state.buildUrl.lastIndexOf("/")+5,this.state.buildUrl.lastIndexOf("_nuro"))),
                    buildUrl: this.state.buildUrl.trim(),
                    firmwareType: this.state.buildType
                };
                break;
            }
            case FIRMWARE_TYPE.WIFI_IMAGE: {
                const wifi = this.state.buildUrl.substring(this.state.buildUrl.lastIndexOf("/")+1);
                request = {
                    revision: wifi.substring(wifi.lastIndexOf("p")+1, wifi.indexOf(".bin")),
                    buildUrl: this.state.buildUrl.trim(),
                    firmwareType: this.state.buildType
                };
                break;
            }
            case FIRMWARE_TYPE.PCB_IMAGE: {
                const pcb = this.state.buildUrl.substring(this.state.buildUrl.lastIndexOf("/")+1);
                let majorTemp = pcb.substring(pcb.lastIndexOf("_0")+2, pcb.indexOf("00"));
                let minorTemp = pcb.substring(pcb.lastIndexOf(majorTemp+"00")+3, pcb.indexOf("0000"));
                let revisionTemp = pcb.substring(pcb.lastIndexOf("00")+2 ,pcb.indexOf(".BIN"));
                request = {
                    major: majorTemp,
                    minor: minorTemp,
                    revision: revisionTemp,
                    buildUrl: this.state.buildUrl.trim(),
                    firmwareType: this.state.buildType
                };
                break;
            }   
         }

         try {
            await BuildService.addBuild(request);
            alert("Build added Successfully.");
            const builds = await BuildService.getBuilds();
            const buildBasedOnDeviceType = this.separateBuildBasedOnDeviceType(builds)
            this.setState({
                buildList: builds,
                switchBuilds: buildBasedOnDeviceType.dataSwitch,
                acBuilds: buildBasedOnDeviceType.dataAc
            })
        } catch (e) {
            alert(e.message);
            console.log(e.message)
        } finally {
            this.setState({
                buildType: FIRMWARE_TYPE.SWITCH_DEVICE_IMAGE,
                buildUrl: "",
                buildDialogErrors: [null, null, null, null, null]
            })
        }
    }

    async updateGoldenBuild(goldenBuildType, goldenBuild) {
        try {
            const request = {};
            request.buildType = goldenBuildType;
            request.build= goldenBuild;
            await BuildService.updateGoldenBuild(request);
            alert("Golden build was successfully updated.");
            await this.getBuildList();
        } catch (e) {
             alert("There was some issue updating golden build");
        } finally {
             this.setState({selectedBuildType: "", selectedBuild: ""})
         }
     }

     async deleteBuild(deleteBuild) {
        try{
            const buildId = this.getBuildId(deleteBuild.buildUrl)
            await BuildService.removeBuild(buildId)
            const builds = await BuildService.getBuilds();
            const buildBasedOnDeviceType = this.separateBuildBasedOnDeviceType(builds)
            this.setState({
                buildList: builds,
                switchBuilds: buildBasedOnDeviceType.dataSwitch,
                acBuilds: buildBasedOnDeviceType.dataAc
            })
            alert("Build removed Successfully.");
        } catch (e) {
            alert(e.message);
            console.log(e.message)
        }
    }

    getBuildId(removeBuild) {
        for(const build of this.state.buildList) {
            if(build.buildUrl === removeBuild) {
            return build.id;
            }
        }
        alert("Build not found !")
    }

    onSelectPremise = function (event) {
        for(const premises of this.state.premisesDeviceList)  {
            if(premises.id == parseInt(event.target.value)) {
                this.setState({
                    selectedPremisesObject: premises,
                    selectedPremises: premises.name,
                    deviceList: premises.deviceList,
                    selectedDevices: [], 
                    selectedAc: []
                })
            }
        }
    }

    getErrorMessage(e) {
        console.log(JSON.stringify(e))
        if(e.response.data && e.response.data.status == 500 || e.response.data.message == undefined) {
            return strings.errorActivatingDevice;
        }

        return e.response.data.message
    }

    render() { 
        return (
            <Container>
                    {this.renderButton()}
                { this.renderAddAndAvailableBuildView() }
            </Container>
        );
    }

    renderButton() {
        return (
                <Col sm={5}>
                    <Button variant="primary" style={{marginLeft: 855}} onClick={this.showGoldenBuildModal}>{strings.updateGoldenBuild}</Button>
                </Col>
            )
    }


    renderAddAndAvailableBuildView() {
        return (
            <div>
                <Row style={{marginTop: 30}}>
                    <h4 style={{width: "700px"}}>{strings.addBuild}</h4>
                </Row>
                <Form>
                    <Form.Group controlId="upgradeForm.ControlInput1">
                        <Row>
                            <Col sm={4}>
                                <Form.Control type="text" placeholder={"URL"}
                                                onChange={this.handleUrlChange}
                                                value={this.state.buildUrl}
                                                style={(this.state.buildDialogErrors[0] == null) ? null : {borderColor: "red"}}/>
                            </Col>

                            <Col sm={3}>
                                <select className="form-control"
                                        onChange={this.onSelectFirmwareType}>
                                    <option value="SWITCH_DEVICE_IMAGE">Switch Firmware</option>
                                    <option value="SWITCH_STM_IMAGE">Switch STM</option>
                                    <option value="AC_DEVICE_IMAGE">AC Firmware</option>
                                    <option value="WIFI_IMAGE">WiFi Firmware</option>
                                    <option value="PCB_IMAGE">PCB Firmware</option>
                                </select>
                            </Col>
                            <Button variant="primary" style={{marginRight: 16}}
                                    onClick={this.validateForm}>{strings.submit}</Button>
                        </Row>
                    </Form.Group>
                </Form>

                <Row style={{marginTop: 32}}>
                    <h4 style={{width: "700px"}}>{strings.availableBuilds}</h4>
                </Row>

                <Row style={{marginTop: 40}}>
                    <Col sm={12}>
                        <BuildsTable
                        build={this.state.buildList}
                        deleteBuild={this.deleteBuild}
                        />
                    </Col>
                </Row>
                <GoldenBuildModal 
                    buildList={this.state.buildList}
                    show={this.state.showUpdateGoldenBuild}
                    onCloseClicked={this.closeGoldenBuildModal}
                    updateGoldenBuild={this.updateGoldenBuild}
                />
          </div>
        )

    }

}